module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/ico_lightning-a3b0bde4647064228ea9f21386962d37.svg";